/**
 * Logout component
 * Created on 13-06-2025
 */

//  Generic imports
import React from "react";
import { useNavigate } from "react-router-dom";

//  Motif imports
import { MotifButton } from "@ey-xd/motif-react";

//  Icons imports
import iconLogin from "../../../assets/images/log-in.svg";
import Logout from "../../../assets/images/logout.svg";
import Eynewlogo from "../../../assets/images/Eynewlogo.svg";

//  Internal imports
import "./LogOut.scss";

export function LogOut() {
  const navigate = useNavigate();

  /**
   * Description
   * -----------
   * This method is to navigate to login page
   */
  const onLoginClick = () => {
    navigate("/");
  };

  return (
    <>
      <div className="ey-logo">
        <img src={Eynewlogo} alt="Logged out" className="logoutimagelogo" />
      </div>
      <div className="logout-container">
        <img src={Logout} alt="Logged out" className="logout-image" />
        <p className="logout-message">You have been signed out due to inactivity</p>
        <p className="logout-subtext">
          Click 'Log in' below to access your projects
          or close the add-in to exit
        </p>
        <MotifButton
          className=" motifLogoutButton"
          onClick={() => {
            onLoginClick();
          }}
        >
          <img src={iconLogin} alt="login icon" />{/*
                */}Log in
        </MotifButton>
      </div>
    </>
  );
}

export default LogOut;
